import moment from "moment";
import { TagColor } from "../../app/data/common/tagColor";

export const statusColor = (status: string): TagColor => {
  if (status === "ACTIVE") {
    return TagColor.GREEN;
  }
  if (status === "PENDING") {
    return TagColor.BLUE;
  }
  return TagColor.GREY;
};

export const statusLabel = (status: string): string => {
  if (!status) {
    return "";
  }
  return status.charAt(0) + status.slice(1).toLowerCase();
};

export const audienceLabel = (recipientType?: string | null): string => {
  if (recipientType === "CUSTOMER") {
    return "Customers";
  }
  if (recipientType === "EMPLOYEE") {
    return "Employees";
  }
  return "";
};

export const formatDay = (value?: string | null): string => {
  if (!value) {
    return "";
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("MMM D, YYYY") : value;
};

export const formatTimestamp = (value?: string | null): string => {
  if (!value) {
    return "";
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("MMM D, YYYY [at] h:mm A") : value;
};

export const formatFileSize = (bytes?: number): string => {
  if (bytes == null || bytes < 0) {
    return "";
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
